<template>
    <div class="p-0">
        
            <div class="bg-white rounded-md">


                <b-modal size="xl" scrollable centered 
                    :id=modalItemUID 
                    title="Items"
                    :header-bg-variant="getTheme.dark"
                    :header-text-variant="getTheme.light"
                    :body-bg-variant="getTheme.light" 
                    :footer-bg-variant="getTheme.light"
                    :footer-text-variant="getTheme.light"
                    @show="resetModal"
                    @hidden="resetModal"
                    @ok="handleOk"
                >
                   <invoiceProducts :searchText="productSearchTxt" @add-products="onSelection" />
                </b-modal>

                <table class="table table-bordered align-items-center table-sm">
                    <thead class="thead-light">
                        <tr>
                            <th>#</th>
                            <th>ItemId</th>
                            <th>Description</th>
                            <th>Type Format</th>
                            <th>Plu1</th>
                            <th>Plu2</th>
                            <th>Plu3</th>
                            <th>Plu4</th>
                            <th>Plu5</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th></th>
                        </tr>
                        <tr>
                            <td colspan="11">
                                <b-input-group size="sm" class="px-2">
                                    <b-input-group-prepend :is-text="true" :tag="span">
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input 
                                        ref="itemSearch" 
                                        type="search" 
                                        name="search" 
                                        autocomplete="off" 
                                        :placeholder="$t('g_Recherche')" 
                                        v-model="searchTerm" 
                                        v-on:keyup.enter="showProductList"
                                    >
                                    </b-form-input>
                                </b-input-group>

                            </td>
                            <td class="text-right text-nowrap">
                                <b-button size="sm" :variant="getTheme.secondary" @click="showProductList">
                                    <b-icon icon="plus" :variant="getTheme.light" font-scale="1"></b-icon><span>Add</span>
                                </b-button>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(field, index) in fields" :key="index" :ref="'itemRow-'+index">
                            <td v-text="index + 1"></td>
                            <td>
                                <span v-text="field.itemid"></span>
                                <!-- <input v-model="field.itemid" type="hidden" name="itemid[]" class="form-control"> -->
                            </td>
                            <td>
                                <span v-text="field.descr"></span>
                                <!-- <input v-model="field.descr" type="hidden" name="descr[]" class="form-control"> -->
                            </td>
                            <td><input v-model="field.formatType" type="text" name="formatType[]" class="form-control"></td>
                            
                            <td><input v-model="field.plu1" type="text" name="plu1[]" class="form-control"></td>
                            <td><input v-model="field.plu2" type="text" name="plu2[]" class="form-control"></td>
                            <td><input v-model="field.plu3" type="text" name="plu3[]" class="form-control"></td>
                            <td><input v-model="field.plu4" type="text" name="plu4[]" class="form-control"></td>
                            <td><input v-model="field.plu5" type="text" name="plu5[]" class="form-control"></td>
                            <td>
                                <s-currencyInput step=1 :decimal=2 :min=0 v-model="field.qty" name="qty[]"></s-currencyInput>
                            </td>
                            <td>
                                <s-currencyInput append="$" :step=0.05 :decimal=2 :min=0 v-model="field.price" name="price[]"></s-currencyInput>
                            </td>
                            <td class="justify-content-center align-items-center">
                                <s-confirmation-button 
                                    :messages="customMessages"
                                    :variant="getTheme.olight"
                                    @confirmation-success="removeField(index)"
                                    @confirmation-reset="removeRowColor(index)"
                                    @confirmation-incremented="highlightRow(index)"
                                >
                                    <template v-slot:icon>
                                        <b-icon icon="trash" :variant="getTheme.danger" font-scale="1"></b-icon>
                                    </template>
                                </s-confirmation-button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="13" class="text-right"></td>
                        </tr>
                    </tfoot>
                </table>
            </div>



    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import invoiceProducts from '@/components/invoice/invoiceProducts/invoiceProducts'

export default{
    name: "invoiceDetail",
    mixins:[mapGetter],
    components: {
        invoiceProducts
    },
    data() {
        return{
            isOn: false,
            fields: [],
            searchText:'',
            modalItemUID: null,
            products :[],
            productSearchTxt : '',
            searchTerm : '',
            isConfirmationBtn : false,
            customMessages: [
                '',
                '',
                '',
            ],
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        removeField(index) {
            this.removeRowColor(index) 
            this.fields.splice(index, 1);
            this.notifyChange(this.fields)
        },
        highlightRow(index) {
            this.addRowColor(index) 
        },
        addRowColor(index) {
            let refname = 'itemRow-'+index
            const element = this.$refs[refname][0]
            element.classList.add('current')
        },
        removeRowColor(index) {
            let refname = 'itemRow-'+index
            const element = this.$refs[refname][0]
            element.classList.remove('current')
        },
        resetModal() {
            
        },
        //Capture l'evenement click sur le bouton OK du modal de la liste des items (produits)
        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()

            this.products.forEach((product) => {
                this.fields.push({
                    itemid: product.id,
                    descr: product.description1,
                    formatType: product.formatType,
                    qty: 1.00,
                    price: 0.00,
                    plu1: product.plu1
                });
            })

            this.products = []


            // Déclencher le gestionnaire du submit
            this.handleSubmit()
        },
        //Gere le submit du modal de la liste de items (Produits)
        handleSubmit() {
            // Fermer le modal manuellement
            this.$nextTick(() => {
                this.close()
            })
        },
        //Ferme le modal de la liste des items
        close() {
            this.$bvModal.hide(this.modalItemUID)
        },
        onSelection(params) {
            let isMultiple = params.isMultiple
            this.products = []

            let invoiceItemsIds = this.fields.map((f) => f.itemid)
            let rows = params.rows.filter(p => invoiceItemsIds.indexOf(p.id)===-1) 

            this.products.push(...rows)

            if(!isMultiple) {
                this.products.forEach((product) => {
                    this.fields.push({
                        itemid: product.id,
                        descr: product.description1,
                        formatType: product.formatType,
                        qty: 1.00,
                        price: 0.00,
                        plu1: product.plu1
                    });
                })
            }

            // Fermer le modal manuellement
            this.$nextTick(() => {
                if(!isMultiple) {
                    this.products = []
                    this.close()
                }
            })
        },
        notifyChange(fields) {
            this.$emit('onItemsChanged', {items: fields});
        },
        showProductList() {
            this.productSearchTxt = this.$CObj(this.searchTerm)
            this.$bvModal.show(this.modalItemUID)
            this.$nextTick(() => {
                this.searchTerm = ''
            })
        }
        
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.modalItemUID = this._uid
        if(typeof this.modalItemUID !== "undefined") {
            this.modalItemUID = this.modalItemUID.toString()
        }
        this.$refs.itemSearch.focus();
    },
//------------------------------------------------------------------------------------------------
    watch: {
        fields: {
            handler(newValue) {
                this.notifyChange(newValue)
            },
            deep: true
        },
    }
}
</script>

<style lang="scss" scoped>
    td {
        text-align: center;
        vertical-align: middle;
    }
    .current {
        background-color: #f0ece5;
        font-weight: bold; 
    }
</style>